<template>
	<div class="tpl my-page-wrap">
		<div class="page-title-bar" v-if="baseInfo.info">
			<p class="user-name">{{baseInfo.info.nickname}}</p>
			<p class="user-info">{{baseInfo.info.age}}岁 | {{baseInfo.info.height}}CM | {{baseInfo.info.education}} | {{baseInfo.info.annual_income}}</p>
			<router-link tag="span" :to="{name:fromPath.name}" class="back">
				<img src="../../assets/img/chats/ic_nav_back_pressed@2x.png" alt="" />
			</router-link>
		</div>
		<div class="user-intro" v-if="baseInfo.info">
			<div class="user-intro-left">
				<div class="left-top">
					<div class="user-img">
						<div class="user-avatar">
							<img :src="baseInfo.info.avatar" />
						</div>
						<span class="sex">
							<img v-if="baseInfo.info.gender==1" src="../../assets/img/common/ic_user_man@2x.png"/>
							<img v-if="baseInfo.info.gender==2" src="../../assets/img/common/ic_user_woman@2x.png"/>
						</span>
					</div>
					<div class="user-intro-text">
						<p class="user-name">
							{{baseInfo.info.nickname}}
							<img v-if="baseInfo.info.is_vip" src="../../assets/img/common/ic_user_vip@2x.png" alt="" />
							<span class="level" v-if="baseInfo.info.is_vip">
								<img src="../../assets/img/mine/user_level_queen.png" alt="" />
								<span class="num">{{baseInfo.info.grade}}</span>
							</span>
						</p>
						<p class="user-info">ID:{{baseInfo.info.uid}} | {{baseInfo.info.city}}</p>
					</div>
				</div>
				<div class="left-bottom">
					<button @click="tabLove(baseInfo.love)">{{baseInfo.love==0?"喜欢":"取消喜欢"}}</button>
					<!--<button>私聊</button>-->
					<button  @click="showGiftList">送礼物</button>
				</div>
			</div>
			<div class="user-intro-right" @click="wraning">
				<p class="user-certi"><img src="../../assets/img/mine/center_center_1.png" alt="" />信用度<img src="../../assets/img/common/ic_arrow_enter@2x.png" alt="" /></p>
				<p class="user-remind"><img src="../../assets/img/mine/center_center_2.png" alt="" />上线提醒</p>
			</div>
		</div>
		<div class="user-show" v-if="baseInfo.info">
			<ul>
				<li v-for="item in baseInfo.info.attach">
					<img :src="item" alt="" />
				</li>
			</ul>
		</div>
		<div class="user-content">
			<mt-navbar v-model="selected">
				<mt-tab-item id="1">资料信息</mt-tab-item>
				<mt-tab-item id="2">动态</mt-tab-item>
			</mt-navbar>

			<!-- tab-container -->
			<mt-tab-container v-model="selected">
				<mt-tab-container-item id="1" class="personal-info" v-if="baseInfo.info">
					<div class="item-wrap">
						<p class="item-title">
							<span class="name">
								<img src="../../assets/img/finds/ic_list_tab@2x.png"/>
								交友宣言
							</span>
						</p>
						<div class="sign-text">
							{{baseInfo.info.sig}}
						</div>
					</div>
					<div class="item-wrap">
						<p class="item-title">
							<span class="name">
								<img src="../../assets/img/finds/ic_list_tab@2x.png"/>
								已认证
							</span>
						</p>
						<div class="certi-list">
							<ul>
								<li v-if="baseInfo.info.is_real"><img src="../../assets/img/mine/center_center_4.png" alt="" /><p>实名认证</p></li>
								<li v-if="baseInfo.info.is_house"><img src="../../assets/img/mine/center_center_5.png" alt="" /><p>房产认证</p></li>
								<li v-if="baseInfo.info.is_education"><img src="../../assets/img/mine/center_center_6.png" alt="" /><p>学历认证</p></li>
								<li v-if="baseInfo.info.is_vehicle"><img src="../../assets/img/mine/center_center_7.png" alt="" /><p>车辆认证</p></li>
							</ul>
							
						</div>
					</div>
					<div class="item-wrap">
						<p class="item-title">
							<span class="name">
								<img src="../../assets/img/finds/ic_list_tab@2x.png"/>
								基本资料(3/8)
							</span>
						</p>
						<div class="baseinfo">
							<ul>
								<li><span class="name">ID</span><span class="value">{{baseInfo.info.uid}}</span></li>
								<li><span class="name">年龄</span><span class="value">{{baseInfo.info.age}}岁</span></li>
								<li><span class="name">身高</span><span class="value">{{baseInfo.info.height}}CM</span></li>
								<li><span class="name">昵称</span><span class="value">{{baseInfo.info.nickname}}</span></li>
								<li><span class="name">性别</span><span class="value">{{baseInfo.info.gender?"男":"女"}}</span></li>
								<li><span class="name">生日</span><span class="value">{{baseInfo.info.birthday}}</span></li>
								<li><span class="name">学历</span><span class="value">{{baseInfo.info.education}}</span></li>
								<li><span class="name">年收入</span><span class="value">{{baseInfo.info.annual_income}}</span></li>
								<li><span class="name">所在地</span><span class="value">{{baseInfo.info.city}}</span></li>
							</ul>
							<p class="tips"><span>立即开通会员vip查看更多高级资料</span><img src="../../assets/img/common/ic_arrow_enter@2x.png"/></p>
						</div>
					</div>
					<div class="item-wrap" v-if="isVip==1">
						<p class="item-title">
							<span class="name">
								<img src="../../assets/img/finds/ic_list_tab@2x.png"/>
								高级资料(3/8)
							</span>
						</p>
						<div class="baseinfo">
							<ul>
								<li><span class="name">购房情况</span><span class="value">{{baseInfo.info.buy_house}}</span></li>
								<li><span class="name">购车情况</span><span class="value">{{baseInfo.info.car_buying}}</span></li>
								<li><span class="name">婚姻</span><span class="value">{{baseInfo.info.marriage}}</span></li>
								<li><span class="name">宗教</span><span class="value">{{baseInfo.info.religion}}</span></li>
								<li><span class="name">子女</span><span class="value">{{baseInfo.info.children}}</span></li>
							</ul>
						</div>
					</div>
					<div class="item-wrap">
						<p class="item-title">
							<span class="name">
								<img src="../../assets/img/finds/ic_list_tab@2x.png"/>
								择偶标准
							</span>
						</p>
						<div class="choose-people">
							<ul>
								<li v-for="item in baseInfo.selection">{{item}}</li>
							</ul>
						</div>
					</div>
					<div class="item-wrap">
						<p class="item-title" @click="showList=1">
							<span class="name">
								<img src="../../assets/img/finds/ic_list_tab@2x.png"/>
								Ta收到的礼物
							</span>
							<span class="option">
								<img src="../../assets/img/common/ic_arrow_enter@2x.png"/>
							</span>
						</p>
						<div class="gift-list">
							<ul>
								<li v-for="item in baseInfo.gift">
									<div class="img-box">
										<div class="img-avatar">
											<img :src="item.avatar"/>
										</div>
										
										<span class="gift-img">
											<img :src="item.girft_img_url" alt="" />
										</span>
									</div>
									<p>{{item.nickname}}</p>
								</li>
							</ul>
						</div>
					</div>
					<div class="item-wrap">
						<p class="item-title">
							<span class="name">
								<img src="../../assets/img/finds/ic_list_tab@2x.png"/>
								足迹地点
							</span>
						</p>
						<div class="manage-add">
							<ul>
								<li v-for="item in baseInfo.footprints">{{item.region_name}}</li>
							</ul>
						</div>
					</div>
				</mt-tab-container-item>
				<mt-tab-container-item id="2">
					<div class="trend-list">
						<trend-item v-for="item in trendsInfo" :key="item.d_id" :uid="uid" :itemInfo="item"  @click.native="goToDetail(item.d_id,'2')"></trend-item>
					</div>
				</mt-tab-container-item>
			</mt-tab-container>
		</div>
		<send-gift @chooseGift="getChoosedGift" ref="giftlist"></send-gift>
		<his-gifts :uid="oid" @showBox="showgBox" @closeList="closeList" v-show="showList"></his-gifts>
		<his-gifts-box :uid="oid" @closeBox="closeBox" v-if="showBox==1"></his-gifts-box>
	</div>
</template>

<script>
	import TrendItem from "../Trends/TrendItem"
	import SendGift from "../Trends/SendGift"
	import HisGifts from "./HisGifts"
	import HisGiftsBox from "./HisGiftsBox"
	
	export default {
		name: "my-page-other",
		components:{
			TrendItem,
			SendGift,
			HisGifts,
			HisGiftsBox
		},
		data() {
			return {
				uid: "",
				oid:"",
				fromPath: "", //来源路由
				isVip:0,
				selected: "1",
				baseInfo:"",
				trendsInfo:"",
				trendPage:1,
				showMendSign:0,
				showMendNickname:0,
				showList:0,
				showBox:0,
			}
		},
		beforeRouteEnter(to, from, next) {
			next((vm) => { //参数vm就是当前组件的实例。
				vm.fromPath = from;
				console.log(vm.fromPath)
			})
		},
		created() {
			this.uid = this.$store.state.UserId; //获取当前用户的id
			this.isVip = this.$store.state.AdminInfo.isvip; //获取当前用户的id
			this.$store.commit("changeTabChoosed", "mine");
			this.$store.commit("changeTabBarShow", false);
			if(this.$route.query.selected){
				this.selected = this.$route.query.selected;
			}
			this.oid = this.$route.query.oid;
			
			this.getBaseInfo();
			
			this.getTrendInfo();
		},
		methods:{
			getBaseInfo(){
				this.$axios({
					url:'My/OtherPersonalInfo',
					method:"post",
					data:{
						uid:this.oid,
						other_uid:this.uid
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.baseInfo = res.data.data;
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			getTrendInfo(){
				this.$axios({
					url:'My/PersonalDynamic',
					method:"post",
					data:{
						uid:this.oid,
						page:this.trendPage
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.trendsInfo = res.data.data;
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			closeMend(s){
				if(s==0){
					this.showMendSign = 0;
					this.showMendNickname = 0;
				}else{
					this.showMendSign = 0;
					this.showMendNickname = 0;
					this.getBaseInfo();
				}
			},
			goToDetail(id,s){
				this.$router.push({
					name:"trend-detail",
					query:{
						id:id,
						selected:s
					}
				})
			},
			tabLove(is_love){
				console.log(is_love);
				let type = is_love==0?1:2;
				console.log(type);
				this.$axios({
					url:"My/UserLike",
					method:"post",
					data:{
						uid:this.uid,
						other_uid:this.oid,
						type:type,
					}
				}).then(res=>{
					console.log(res);
					this.$toast({
						message:res.data.msg,
						position:"bottom",
						duration:3000
					})
					if(res.data.code==200){
						this.getBaseInfo();
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			getChoosedGift(gift){
				console.log(gift)
				let data = {
					uid:this.uid,
					other_uid:this.oid,
					g_id:gift.g_id,
					g_nums:gift.num
				}
				console.log(data);
				this.$axios({
					url:"Chat/Giving",
					method:"post",
					data:data
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.$toast({
							message:res.data.msg,
							position:"bottom",
							duration:3000
						})
						this.getBaseInfo();
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			showGiftList(){
				this.$refs.giftlist.showGiftList();
			},
			closeList(){
				this.showBox = 0;
				this.showList = 0;
			},
			closeBox(){
				this.showBox = 0;
				this.showList = 1;
			},
			showgBox(){
				this.showBox = 1;
			},
			wraning(){
				this.$toast({
					message:"请至鱼水缘App进行此操作",
					position:"bottom",
					duration:3000
				})
			}
		}
	}
</script>

<style scoped>
	.my-page-wrap {
		padding-top: 3rem;
	}
	
	.page-title-bar {
		text-align: center;
		background: #FFFFFF;
		padding: 0.3rem 0;
		position: fixed;
		width: 100%;
		top: 0;
		left: 0;
		z-index: 10;
		border-bottom: 1px solid #f3f3f3;
	}
	
	.page-title-bar .user-name {
		font-size: 0.8rem;
		color: #282828;
		font-weight: bold;
		line-height: 1.2rem;
	}
	
	.page-title-bar .user-info {
		font-size: 0.65rem;
		color: #7b7b7b;
	}
	
	.page-title-bar .back {
		position: absolute;
		top: 0.15rem;
		left: 0rem;
	}
	
	.page-title-bar .back img {
		width: 2.5rem;
	}
	>>>.mint-navbar .mint-tab-item.is-selected{
		border-bottom-color: #8157F7;
	}
	
	.user-intro {
		background: #fff;
		padding: 1.5rem 1rem 0.5rem;
		text-align: center;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.user-intro-left{
		flex: 1;
	}
	.user-intro-left .left-top{
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.user-intro-left .left-bottom{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 0.5rem 0.8rem 0.5rem 0;
	}
	.user-intro-left .left-bottom button{
		width: 30%;
		border: 1px solid #875BF0;
		background: none;
		color: #5415F9;
		outline: 0;
		border-radius: 4px;
		font-size: 0.8rem;
		padding: 0.2rem 0;
		margin-right: 0.5rem;
	}
	.user-intro .user-img {
		position: relative;
		display: flex;
		justify-content: center;
	}
	
	.user-intro .user-avatar {
		display: inline-block;
		width: 3rem;
		height: 3rem;
		border-radius: 50%;
		overflow: hidden;
		display: flex;
		justify-content: center;
		align-items: center;
		border: 1px solid #fafafa;
	}
	
	.user-intro .user-avatar img {
		width: 3rem;
		display: block;
	}
	.user-intro .user-intro-text{
		padding: 0 0.5rem;
	}
	.user-intro .user-name .level {
		position: relative;
	}
	
	.user-intro .user-name .level img {
		width: 1.5rem;
		display: block;
		margin-left: 0;
	}
	.user-intro .user-name .level .num {
		font-size: 0.65rem;
	    color: #fff;
	    position: absolute;
	    top: 0.6rem;
	    left: 0.5rem;
	}
	
	.user-intro .user-img .sex {
		position: absolute;
		top: 1.9rem;
		left: calc(50% + 0.3rem);
		background: #fff;
		border-radius: 50%;
	}
	
	
	.user-intro .user-img .sex img {
		width: 1.2rem;
		display: block;
	}
	
	.user-intro .user-name {
		font-size: 1rem;
		color: #282828;
		font-weight: bold;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	
	.user-intro .user-name img {
		width: 1.8rem;
		margin-left: 0.5rem;
	}
	
	.user-intro .user-info {
		font-size: 0.8rem;
		color: #7b7b7b;
		line-height: 1.5rem;
	}
	.user-intro .user-intro-right{
		border-left: 1px solid #f3f3f3;
		padding-left: 0.8rem;
	}
	.user-intro .user-intro-right p{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 0.8rem;
		color: #282828;
		padding: 0.8rem 0;
	}
	.user-intro .user-intro-right p:first-of-type{
		border-bottom: 1px solid #f3f3f3;
	}
	.user-intro .user-intro-right p img{
		width: 1.5rem;
		margin-right: 0.5rem;
	}
	
	.user-show ul {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		width: 100%;
		margin: 0.3rem 0 0.5rem;
		overflow-x: scroll;
	}
	
	.user-show li {
		padding: 0 0.2rem;
		background: #fff;
	}
	
	.user-show li img {
		height: 8rem;
		width: auto;
		display: block;
	}
	.personal-info .item-title{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0.5rem;
		background: #fff;
		margin-top: 4px;
	}
	.personal-info .item-title:active{
		background: #fafafa;
	}
	.personal-info .item-title span{
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.personal-info .item-title span.name{
		font-size: 1rem;
		color: #282828;
		font-weight: bold;
	}
	.personal-info .item-title span.name img{
		width: 1.2rem;
		margin-right: 0.5rem;
	}
	.personal-info .item-title span.option{
		font-size: 0.8rem;
		color: #7b7b7b;
	}
	.personal-info .item-title span.option img{
		width: 1.5rem;
	}
	.personal-info .sign-text{
		font-size: 0.8rem;
		color: #282828;
		line-height: 1.4rem;
		margin: 2px 0;
		padding: 0.8rem;
		background: #fff;
	}
	.personal-info .certi-list{
		padding: 0.8rem;
		background: #fff;
		margin-top: 2px;
	}
	.personal-info .certi-list li{
		display: inline-block;
		width: 23%;
		text-align: center;
		padding: 0.5rem;
		font-size: 0.65rem;
		color: #7b7b7b;
		box-sizing: border-box;
	}
	.personal-info .certi-list li img{
		width: 2rem;
		display: inline-block;
	}
	.personal-info .baseinfo ul{
		padding-left:1.5rem;
		margin-top: 2px;
		background: #fff;
	}
	.personal-info .baseinfo li{
		padding: 0.5rem 0.8rem;
		border-bottom: 1px solid #f3f3f3;
		background: #fff;
	}
	.personal-info .baseinfo li .name{
		width: 5rem;
		display: inline-block;
		font-size: 0.8rem;
		color: #7b7b7b;
	}
	.personal-info .baseinfo li .value{
		font-size: 0.8rem;
		color: #282828;
	}
	.personal-info .baseinfo .tips{
		color: #5415F9;
		background: rgba(84,21,249,.1);
		font-size: 0.8rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0.5rem 1rem;
	}
	.personal-info .baseinfo .tips img{
		width: 1.5rem;
	}
	.personal-info .choose-people,
	.personal-info .manage-add{
		padding: 0.8rem;
		background: #fff;
		margin: 2px 0;
	}
	.personal-info .choose-people li,
	.personal-info .manage-add li{
		display: inline-block;
		margin: 0.3rem;
		background: #FF6161;
		padding: 0.3rem 1rem;
		border-radius: 3px;
		font-size: 0.8rem;
		color: #fff;
		opacity: 0.7;
	}
	.personal-info .choose-people li:nth-child(even){
		background: #01AEF0;
	}
	.personal-info .manage-add li{
		background: #5415F9;
		opacity: 0.5;
	}
	.personal-info .gift-list ul{
		width: 100%;
		overflow-x: scroll;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 1px 0;
		background: #fefefe;
	}
	.personal-info .gift-list li{
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: 1rem;
		background: #fff;
	}
	.personal-info .gift-list li .img-box{
		position: relative;
	}
	.personal-info .gift-list li .img-avatar{
		width: 2.4rem;
		height: 2.4rem;
		overflow: hidden;
		border-radius: 50%;
		border: 2px solid #f5f5f5;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.personal-info .gift-list li:nth-of-type(1) .img-avatar{
		border-color: #ffe87c;
	}
	.personal-info .gift-list li:nth-of-type(2) .img-avatar{
		border-color: #bdbdbd;
	}
	.personal-info .gift-list li:nth-of-type(3) .img-avatar{
		border-color: #e4a13f;
	}
	.personal-info .gift-list li p{
		font-size: 0.8rem;
		color: #7b7b7b;
		margin-top: 0.5rem;
	}
	
	.personal-info .gift-list .img-avatar>img{
		width: 2.4rem;
		display: block;
	}
	.personal-info .gift-list .gift-img{
		width: 1.5rem;
		height: 1.5rem;
		border-radius: 50%;
		overflow: hidden;
		position: absolute;
		background: #fff;
		right: -0.5rem;
		bottom: -0.3rem;
	}
	.personal-info .gift-list .gift-img img{
		width: 1.5rem;
		display: block;
	}
	
	.trend-list ul{
		padding-top: 4px;
	}
	.trend-list li{
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		padding: 0.5rem 1rem;
		background: #fff;
		border-bottom: 1px solid #f3f3f3;
	}
	.trend-list li .send-trend img{
		width: 5rem;
		display: block;
	}
	.trend-list li .item-time{
		width: 4rem;
	}
	.trend-list li .item-date{
		font-size: 1.1rem;
		line-height: 1.8rem;
		font-weight: bold;
	}
	.trend-list li .item-date .month{
		padding-left: 0.5rem;
		font-size: 1rem;
		font-weight: 600;
	}
	.trend-list li .item-address{
		font-size: 0.8rem;
		color: #282828;
	}
	.trend-list li .item-content,
	.trend-list li .item-content>div{
		flex: 1;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.trend-list li .content-inner{
		padding: 0.5rem 0.7rem;
		background: #f3f3f3;
	}
	.trend-list li .item-img{
		min-width: 4rem;
		min-height: 4rem;
		max-width: 4rem;
		max-height: 4rem;
		display: block;
		overflow: hidden;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.trend-list li .item-img img{
		width: 4rem;
		display: block;
	}
	.trend-list li .item-img .video-play{
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		background: rgba(0,0,0,.3);
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.trend-list li .item-img .video-play img{
		width: 2rem;
	}
	.trend-list li .item-text{
		font-size: 0.8rem;
		color: #282828;
		word-break:break-all;
		display:-webkit-box;
		-webkit-line-clamp:3;
		-webkit-box-orient:vertical;
		overflow:hidden;
		padding: 0 0.3rem;
	}
	
	
	
	.no-content{
		padding: 0;
		text-align: left;
	}
</style>


// WEBPACK FOOTER //
// src/components/Mine/MyPageOther.vue